export const requirements = {
  Mapped_Protocol_Questions: "Preguntas de protocolo asignadas",
  Requirement_content: "Contenido del requisito",
  Requirement_Ref: "Requisito de referencia",
  Requirements: "Requisitos",
  Section_Ref: "Referencia de sección",
  Section_Title: "Título de la sección",
  Standard: "Estándar",
  Standard_Requirements: "Requisitos estándar",
  Standards: "Estándaros",
  Sub_Section_Ref: "Ref de subsección",
  Sub_Section_Title: "Título de la subsección",
} as const;
